import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Checkbox } from '@/components/ui/checkbox';
import { Field, FieldError, FieldLabel } from '@/components/ui/field';
import { useTaskFieldEdit } from './TaskFieldEditContext';

type TicketCheckboxFieldProps = {
  title: string;
  fieldName: string;
  disabled?: boolean;
};

export const TicketCheckboxField: React.FC<TicketCheckboxFieldProps> = ({
  title,
  fieldName,
  disabled,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { autoPersist, persistTip } = useTaskFieldEdit();
  const error = errors[fieldName]?.message as string | undefined;

  return (
    <Field
      orientation="horizontal"
      className="tw:items-center"
      data-invalid={error ? true : undefined}
    >
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => (
          <Checkbox
            id={fieldName}
            checked={Boolean(field.value)}
            disabled={disabled}
            onCheckedChange={(checked) => {
              field.onChange(checked === true);
              if (autoPersist) void persistTip();
            }}
          />
        )}
      />
      <FieldLabel htmlFor={fieldName} className="tw:font-normal">
        {title}
      </FieldLabel>
      <FieldError>{error}</FieldError>
    </Field>
  );
};
